export const getAuditState = store => store.audit;
export const getAuditUsers = store => getAuditState(store).users;
